import store from 'redux-store/store';
import { PROFILES, ROLES_PRORROGA } from 'CONST';
import { intermediaryAccess } from './helpers';

export default function isUserHasProfile(validProfiles) {
  const state = store.getState();
  const userProfiles = state.login.user.profiles;
  const { user } = state.login;
  const isIntermediary = intermediaryAccess(user);

  // Si es distinto de intermediario (o sea es asegurado), revisa si el perfil ficticio solo vista es valido
  if (
    !user.is_orsan &&
    !isIntermediary &&
    validProfiles.includes(PROFILES.externoAseguradoCreditoSoloVista)
  ) {
    return true;
  }

  for (let index = 0; index < userProfiles.length; index += 1) {
    const profile = userProfiles[index];
    if (validProfiles.includes(profile)) {
      return true;
    } 
  }

  return false;
}
